// Customkonfiguration
export const customConfig = {
    /** Title of custom App */
    title: "Hypersoft - Demo",
    /** Title of the company */
    company: "Hypersoft",
    /** Version of custom app */
    version: "1.9.1014",
    /** Meta Description */
    meta_description: "Lernen Sie Ihr Lieblingsrestaurant kennen, werfen Sie einen Blick auf die Speisekarte und bestellen Sie leckere Speisen und Getränke.",
    /** Meta Description */
    meta_pixel: "1025248469251688",
    /** Chef Campaigns cid */
    chef_campaigns_cid: "",
    /** Chef Campaigns eid */
    chef_campaigns_eid: "",
    /** custom json, posible to inject custom values to code,
     *  without change base code, of the app.
     *  We need to change it to real custom extensions.
     */
    custom_json: "",
};
